import { Component } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Direction } from '@angular/cdk/bidi';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { CLOSE, STATION_NOT_ACTIVE } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-station-not-active-pop-up',
    templateUrl: './station-not-active-pop-up.component.html',
    styleUrl: './station-not-active-pop-up.component.scss',
    standalone: false
})
export class StationNotActivePopUpComponent extends PopUpComponent {

  direction: Direction
  stationNotActiveText: string
  closeText: string


  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    private readonly languageService: LanguageService,

  ) {
    super(routePlanningService, resizeService, overlay);
  }


  override ngOnInit(): void {
    super.ngOnInit()
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      this.stationNotActiveText = STATION_NOT_ACTIVE[language.language]
    })
  }
}
